'use client';

import Link from "next/link";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-gray-900 to-black text-white px-4 py-16">
      <div className="text-center max-w-2xl mx-auto">
        <div className="relative mb-6">
          <h1 className="text-7xl md:text-8xl font-bold text-blue-500 animate-pulse">404</h1>
        </div>
        
        <h2 className="text-2xl md:text-3xl font-semibold mb-4">
          Page Not Found
        </h2>
        
        <p className="text-lg text-gray-300 mb-4">
          Oops! This page seems to have stepped out of the meeting.
        </p>
        <p className="text-gray-400 mb-8">
          Just like that colleague who disappears right before they&apos;re assigned a task, this page is nowhere to be found.
        </p>

        <div className="text-left max-w-md mx-auto mb-10">
          <p className="font-semibold mb-3 text-gray-200">What you can do now:</p>
          <ol className="list-decimal list-inside space-y-2 text-gray-400">
            <li>
              <Link href="/" className="text-blue-400 hover:text-blue-300 hover:underline">
                Return to the homepage
              </Link> and start fresh.
            </li>
            <li>
              Check the URL in your browser&apos;s address bar to make sure it&apos;s spelled correctly.
            </li>
            <li>
              <Link href="/contact" className="text-blue-400 hover:text-blue-300 hover:underline">
                Contact our support team
              </Link> if you think something&apos;s wrong on our end.
            </li>
          </ol>
        </div>

      </div>
    </div>
  );
} 